<template>
  <svg class="button__border-decor button__border-decor--left" width="13" height="53" viewBox="0 0 13 70" xmlns="http://www.w3.org/2000/svg"> <path d="M13 0H6C2.6863 0 0 2.68629 0 6V57.7914C0 59.3827 0.632141 60.9088 1.75736 62.0341L7.96593 68.2426C9.09115 69.3679 10.6173 70 12.2086 70H13V69H12.2086C10.8825 69 9.61072 68.4732 8.67304 67.5355L2.46447 61.327C1.52678 60.3893 1 59.1175 1 57.7914V6C1 3.23858 3.23858 1 6 1H13V0Z" /></svg>
</template>

<script>
export default {
  name: "MainButtonDecorLeftMedium",
};
</script>
